import { Typography } from '@mui/material'
import React, { memo, useCallback, useState } from 'react'
import tw from 'twin.macro'
import { InfoContainer } from 'src/components/shared/InfoContainer'
import { BulletPointText } from 'src/components/shared/BulletPointText'
import { CommonModal } from 'src/components/shared/CommonModal'

const MVRValidRulesComponent = () => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const closeModal = useCallback(() => {
    setShowModal(false)
  }, [])

  return (
    <>
      <Typography variant="h3">For a report to be valid</Typography>
      <BulletPointText className={tw`mb-6 mt-4`} index={1}>
        It cannot be more than 60 days old from the day it was run.
      </BulletPointText>
      <BulletPointText className={tw`mb-6`} index={2}>
        It must show your driver's license number and driving records of 3 or more years, including
        all citations.
      </BulletPointText>
      <BulletPointText className={tw`mb-6`} index={3}>
        The entire report must be uploaded for review, if pages are missing, it cannot be approved.
      </BulletPointText>
      <BulletPointText className={tw`mb-4`} index={4}>
        Follow the example below to avoid uploading wrong document
      </BulletPointText>
      <InfoContainer className={tw`mb-6 rounded-lg`} onClick={openModal}>
        Motor Vehicle Record example
      </InfoContainer>
      <CommonModal
        isOpen={showModal}
        image={require('../../../assets/images/mvr-example.png')}
        onClose={closeModal}
      />
    </>
  )
}

export const MVRValidRules = memo(MVRValidRulesComponent)
